import { render, staticRenderFns } from "./customerScaleAdd.vue?vue&type=template&id=baebac8e&scoped=true"
import script from "./customerScaleAdd.vue?vue&type=script&lang=js"
export * from "./customerScaleAdd.vue?vue&type=script&lang=js"
import style0 from "./customerScaleAdd.vue?vue&type=style&index=0&id=baebac8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baebac8e",
  null
  
)

export default component.exports